import React, { useState } from "react";
import CardImage from "../../../newComponents/cardImage";
import ImgixFluidImage from "../../../newComponents/ImgixFluidImage";
import { useDisclosure } from "@chakra-ui/react";
import { ModalComponent } from "../../../newComponents/modalComponent";

function ImageGroup({blocks}) {

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedItem, setSelectedItem] = useState([0, 0]);

  return (
    <section>
      <div className="shell">
        <header className="section__head"></header>
        <div className="boxes swiper-container js-load-more js-slider-boxes-projects">
          <ul>
            {blocks.map((block, blockIndex) => {

              let ar = "";
              switch (block.aspectRatio) {
                case "16:9":
                  ar = 16/9;
                  break;
                case "4:3":
                  ar = 4/3
                  break;
                case "3:2":
                  ar = 3/2;
                  break;
                case "1:1":
                  ar = 1;
                  break;
                default:
                  ar = false;
                  break;
              }

              return (
                block.image.map((item, itemIndex) => (
                  <CardImage key={`${item.title}`} ar={ar || item.width / item.height} featureImage={item} title={item.title} url={item.assetLinkUrl} onClick={() => {
                    onOpen();
                    setSelectedItem([blockIndex, itemIndex]);
                  }}/>
                ))
              );
            })}
          </ul>
          <div className="swiper-pagination boxes__pagination" />
        </div>
        <ModalComponent isOpen={isOpen} onClose={onClose}>
          <ImgixFluidImage attribution={blocks[selectedItem[0]].image[selectedItem[1]].attribution} image={blocks[selectedItem[0]].image[selectedItem[1]]} width={500} height={500} focalPoint={blocks[selectedItem[0]].image[selectedItem[1]].focalPoint} />  
        </ModalComponent>
      </div>
    </section>
  );
}

export default ImageGroup;
